import styled from "styled-components";
import {useAdConfig, useAdImpression, useAdUnits, useAdView} from "../../api/ads";
import {useBaseCommunity, useFeedAdUnits, useLoggedIn, useStoreProfile} from "../../store";
import {themecolors} from "../../utils/themecolors";
import useModal from "../../modals";
import React, {useEffect, useRef, useState} from "react";
import PostActions from "../post_actions";
import {useIsVisible} from "../../utils/visibility";
import useFeedback from "../../utils/use_feedback";
import {useActions} from "../../app_context";
import {useSheetModal} from "../test/ModalContext";
import Sheet from "../bottom-sheet/sheet";
import SignupPromptSheet from "../bottom-sheet/signup_prompt";
import ProSignupSheet from "../bottom-sheet/pro/pro_signup";
import ErrorBoundary from "../error_boundary";
import useVisitorId from "../../utils/ad_utils";
import {handleAdImp} from "../../utils/route_change";
import {useLocation} from "react-router-dom";

const Container = styled.div``;
const Heading = styled.div``;
const Pro = styled.div``;
const Title = styled.div``;

const Disclosure = styled.div``;
const Item = styled.div``;
const Image = styled.div``;
const Text = styled.div``;
const Brand = styled.div``;

const UnderPostUnit = styled(({adUnits, className, view, impress}) => {

    const location = useLocation();
    const visitorId = useVisitorId();
    const { referrer: signupReferrer, username } = useStoreProfile();

    const [unit, setUnit] = useState(false);
    useEffect(() => {
        if (!unit) {
            setUnit(adUnits?.ads.length > 0 ? adUnits.ads.shift() : false);
        }
    }, [adUnits])

    const ref = useRef(null);
    const isVisible = useIsVisible(ref);
    const [hasViewed, setHasViewed] = useState(false);
    useEffect(async () => {
        if (isVisible && !hasViewed) {
            // register view
            setHasViewed(true);
        }
    }, [isVisible])

    useEffect(async () => {
        if (unit) {
            // register impression
            handleAdImp(visitorId, signupReferrer, username)(location);
            await impress(unit?.impression, unit?.source, "under-post");
            await view(unit?.impression, unit?.source, "under-post");
        }
    }, [unit])

    return  <Container className={className} ref={ref}>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', flexGrow: 1, overflow: 'hidden'}}>
                    <a href={unit.url} target={"_blank"} style={{padding: '12px 16px 12px 16px'}}>
                        <Item>
                            <Image>
                                <img src={unit.image} />
                            </Image>
                            <Text>
                                <Title>
                                    {unit.headline}
                                </Title>
                                <Brand>
                                    Ad by {unit.brand}
                                </Brand>
                            </Text>
                        </Item>
                    </a>
                </div>
            </Container>
    ;
})`
  cursor: pointer;
  align-items: center;
  
  ${Heading} {
    display: flex;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    align-items: center;
    font-weight: 500;
  }
  ${Disclosure} {
    font-weight: 500;
    font-size: 14px;
  }
  ${Pro} {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    cursor: pointer;
  }
  ${Item} {
    display: flex;
  }
  ${Image},
  ${Image} img {
    min-width: 72px;
    min-height: 72px;
    max-height: 72px;
    max-width: 72px;
    border-radius: 8px;
  }
  ${Image} {
    margin-right: 12px;
  }
  ${Text} {
    display: flex;
    font-weight: 500;
    flex-direction: column;
  }
  ${Brand} {
    font-size: 13px;
    font-weight: 400;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Title} {
    font-size: 14px;
    font-weight: 600;
  }
`;

const DisclosureHeading = styled.div``;

const InFeedCard = styled(({adUnits, className, feedKey, index, view, impress}) => {

    const cachedAds = useFeedAdUnits(feedKey);
    const actions = useActions();

    const [unit, setUnit] = useState(false);
    const [hasViewed, setHasViewed] = useState(false);
    const numAds = adUnits?.ads.length;

    useEffect(() => {
        if (!hasViewed) {
            if (cachedAds && index.toString() in cachedAds){
                if (!unit) {
                    const cachedValue = cachedAds[index.toString()];
                    // restore the unit
                    setHasViewed(true);
                    setUnit(cachedValue);
                }
            } else {
                setUnit(adUnits?.ads.length > 0 ? adUnits.ads[0] : false);
            }
        }
    }, [numAds])

    const loggedIn = useLoggedIn();
    const modal = useModal();

    const { openModal } = useSheetModal();
    const handlePro = () => {
        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);


        } else {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><ProSignupSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }
    };

    const ref = useRef(null);
    const isVisible = useIsVisible(ref);
    useEffect(async () => {
        if (unit && isVisible && !hasViewed) {
            adUnits?.ads.shift();
            setHasViewed(true);
            actions.feedAdUnitsChanged(feedKey, index, unit);
            await impress(unit?.impression, unit?.source, "condensed-feed");
            await view(unit?.impression, unit?.source, "condensed-feed");
        }
    }, [isVisible, unit])

    return <div ref={ref}>
                {unit && <Container className={className}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flexGrow: 1,
                        overflow: 'hidden'
                    }}>
                        <Heading>
                            <Disclosure>
                                <DisclosureHeading>
                                    {unit.brand}
                                </DisclosureHeading>
                            </Disclosure>
                            <Pro onClick={handlePro}>Ad</Pro>
                        </Heading>
                        <a href={unit.url} target={"_blank"}>
                            <Item>
                                <Text>
                                    <Title>
                                        {unit.headline}
                                    </Title>
                                </Text>
                                <Image>
                                    <img src={unit.image}/>
                                </Image>
                            </Item>
                        </a>
                    </div>
                    <PostActions/>
                </Container>
                }
            </div>
    ;
})`
  cursor: pointer;
  align-items: center;
  padding-top: 16px;
  
  ${Heading} {
    display: flex;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    align-items: center;
    font-weight: 500;
    padding: 0 16px;
  }
  ${Disclosure} {
    font-weight: 400;
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Pro} {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 15px;
    cursor: pointer;
  }
  ${Item} {
    display: flex;
    flex-direction: column;
    padding-top: 6px;
  }
  ${Image},
  ${Image} img {
    max-height: 400px;
    min-height: 400px;
    width: 100%;
    max-width: 500px;
  }
  ${Image} {
    padding-top: 12px;
    margin: 0 auto;
  }
  ${Text} {
    display: flex;
    font-weight: 500;
    flex-direction: column;
    padding: 0 16px;
  }
  ${Brand} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Title} {
    font-size: 15px;
  }
  ${({theme}) =>
    `& {
        border-top: 1px solid ${theme.color.name === 'dark' ? themecolors.dark_background_4 : themecolors.lighter_border};
    }`
}  
`;

const InFeedCondensed = styled(({adUnits, className, feedKey, index, view, impress}) => {

    const location = useLocation();
    const visitorId = useVisitorId();
    const { referrer: signupReferrer, username } = useStoreProfile();

    const cachedAds = useFeedAdUnits(feedKey);
    const actions = useActions();

    const [unit, setUnit] = useState(false);
    const [hasViewed, setHasViewed] = useState(false);
    const numAds = adUnits?.ads.length;

    useEffect(() => {
        if (!hasViewed) {
            if (cachedAds && index.toString() in cachedAds){
                if (!unit) {
                    const cachedValue = cachedAds[index.toString()];
                    // restore the unit
                    setHasViewed(true);
                    setUnit(cachedValue);
                }
            } else {
                setUnit(adUnits?.ads.length > 0 ? adUnits.ads[0] : false);
            }
        }
    }, [numAds])

    const loggedIn = useLoggedIn();
    const modal = useModal();

    const { openModal } = useSheetModal();
    const handlePro = () => {
        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);


        } else {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><ProSignupSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }
    };

    const ref = useRef(null);
    const isVisible = useIsVisible(ref);
    useEffect(async () => {
        if (unit && isVisible && !hasViewed) {
            adUnits?.ads.shift();
            setHasViewed(true);
            handleAdImp(visitorId, signupReferrer, username)(location);
            actions.feedAdUnitsChanged(feedKey, index, unit);
            await impress(unit?.impression, unit?.source, "condensed-feed");
            await view(unit?.impression, unit?.source, "condensed-feed");
        }
    }, [isVisible, unit])

    return <div ref={ref}>
            {unit &&
                <Container className={className}>
                    <a href={unit.url} target={"_blank"}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flexGrow: 1,
                        overflow: 'hidden',
                        paddingTop: '16px',
                    }}>
                        <Heading>
                            <Disclosure>
                                <DisclosureHeading>
                                    {unit.brand}
                                </DisclosureHeading>
                            </Disclosure>
                            <Pro onClick={handlePro}>Ad</Pro>
                        </Heading>
                            <Item>
                                <Text>
                                    <Title>
                                        {unit.headline}
                                    </Title>
                                </Text>
                                <Image>
                                    <img src={unit.image}/>
                                </Image>
                            </Item>
                    </div>
                    </a>
                    <PostActions/>
                </Container>
            }
    </div>
    ;
})`
  cursor: pointer;
  align-items: center;
  
  ${Heading} {
    display: flex;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    align-items: center;
    font-weight: 500;
    padding: 0 16px;
    padding-bottom: 8px;
  }
  ${Disclosure} {
    font-weight: 400;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Pro} {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-weight: 400;
    cursor: pointer;
  }
  ${Item} {
    padding-top: 6px;
    display: flex;
    width: 100%;
    padding: 0 16px;
  }
  ${Image},
  ${Image} img {
    min-width: 82px;
    max-width: 82px;
    height: 62px;
    border-radius: 8px;
  }
  ${Image} {
    margin-left: auto;
  }
  ${Text} {
    display: flex;
    flex-direction: column;
    padding-right: 8px;
    margin-bottom: 12px;
  }
  ${Brand} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Title} {
    font-size: 14px;
    font-weight: 600;
  }
  ${({theme}) =>
    `& {
        border-bottom: 1px solid ${theme.color.name === 'dark' ? themecolors.dark_background_4 : themecolors.lighter_border};
    }`
}  
`;

const InFeedCardSmall = styled(({adUnits, className, feedKey, index, view, impress}) => {

    const location = useLocation();
    const visitorId = useVisitorId();
    const { referrer: signupReferrer, username } = useStoreProfile();

    const cachedAds = useFeedAdUnits(feedKey);
    const actions = useActions();

    const [unit, setUnit] = useState(false);
    const [hasViewed, setHasViewed] = useState(false);
    const numAds = adUnits?.ads.length;

    useEffect(() => {
        if (!hasViewed) {
            if (cachedAds && index.toString() in cachedAds){
                if (!unit) {
                    const cachedValue = cachedAds[index.toString()];
                    // restore the unit
                    setHasViewed(true);
                    setUnit(cachedValue);
                }
            } else {
                setUnit(adUnits?.ads.length > 0 ? adUnits.ads[0] : false);
            }
        }
    }, [numAds])

    const loggedIn = useLoggedIn();
    const modal = useModal();

    const { openModal } = useSheetModal();
    const handlePro = () => {
        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);


        } else {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><ProSignupSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }
    };

    const ref = useRef(null);
    const isVisible = useIsVisible(ref);
    useEffect(async () => {
        if (unit && isVisible && !hasViewed) {
            adUnits?.ads.shift();
            setHasViewed(true);
            handleAdImp(visitorId, signupReferrer, username)(location);
            actions.feedAdUnitsChanged(feedKey, index, unit);
            await impress(unit?.impression, unit?.source, "condensed-feed");
            await view(unit?.impression, unit?.source, "condensed-feed");
        }
    }, [isVisible, unit])

    return <div ref={ref}>
        <Container className={className}>
            <a href={unit.url} target={"_blank"}>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', flexGrow: 1, overflow: 'hidden',
            paddingTop: '16px'}}>
                <Heading>
                    <Disclosure>
                        <DisclosureHeading>
                            {unit.brand}
                        </DisclosureHeading>
                    </Disclosure>
                    <Pro onClick={handlePro}>Ad</Pro>
                </Heading>
                    <Item>
                        <Text>
                            <Title>
                                {unit.headline}
                            </Title>
                        </Text>
                        <Image>
                            <img src={unit.image} />
                        </Image>
                    </Item>
            </div>
            </a>
            <PostActions />
        </Container>
    </div>
    ;
})`
  cursor: pointer;
  align-items: center;
  
  ${Heading} {
    display: flex;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    align-items: center;
    font-weight: 500;
    padding: 0 16px;
    padding-bottom: 8px;
  }
  ${Disclosure} {
    font-weight: 400;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Pro} {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-weight: 400;
    cursor: pointer;
  }
  ${Item} {
    padding-top: 6px;
    display: flex;
    width: 100%;
    padding: 0 16px;
  }
  ${Image},
  ${Image} img {
    min-width: 82px;
    max-width: 82px;
    height: 62px;
    border-radius: 8px;
  }
  ${Image} {
    margin-left: auto;
  }
  ${Text} {
    display: flex;
    flex-direction: column;
    padding-right: 8px;
    margin-bottom: 12px;
  }
  ${Brand} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Title} {
    font-size: 15px;
    font-weight: 600;
  }
  ${({theme}) =>
    `& {
        border-top: 1px solid ${theme.color.name === 'dark' ? themecolors.dark_background_4 : themecolors.lighter_border};
    }`
}  
`;

const AdUnit = ({postPage, feedKey, index}) => {

    const {feedbackCh} = useFeedback();
    const {expand, pro_tier} = useStoreProfile();

    const adConfig = useAdConfig();

    // list of IDs in feed

    const adUnits = useAdUnits();
    const view = useAdView(feedbackCh);
    const impress = useAdImpression(feedbackCh);

    const cachedAds = useFeedAdUnits(feedKey);
    const [adCount, setAdCount] = useState(adUnits?.ads?.length || 0);

    useEffect(() => {
        if (adUnits?.ads?.length > adCount) setAdCount(adUnits?.ads?.length || 0);
    }, [adUnits]);

    if (pro_tier > 0) return false;

    const v2 = adConfig ? adConfig.v2.activePlacements : false;
    if (!v2) return false;

    const isCachedAd = cachedAds && index.toString() in cachedAds;

    if (!adUnits || !adUnits.ads || (adCount === 0 && !isCachedAd)) return false;

    // todo: here, check if adUnits is empty and reload if so

    if (postPage) {
        return <PreAd adUnits={adUnits} view={view} impress={impress} config={v2.mobileWebPost} placement={'mobileWebPost'} />;
    } else if (expand === "card") {
        const unit = v2.mobileWebFeedCard.rate > 0 ? 'mobileWebFeedCard' : 'mobileWebFeedCardSmall';
        return <PreAd feedKey={feedKey} index={index} adUnits={adUnits} view={view} impress={impress} config={unit === 'mobileWebFeedCard' ? v2.mobileWebFeedCard : v2.mobileWebFeedCardSmall} placement={unit} />
    } else if (expand !== "card") {
        return <PreAd feedKey={feedKey} index={index} adUnits={adUnits} view={view} impress={impress} config={v2.mobileWebFeedCondensed} placement={'mobileWebFeedCondensed'} />
    }
    return false;
};

export const DecideAd = styled(({className}) => {

    const iframeContent = '<div id="ld-2737-9364"></div><script>(function(w,d,s,i){w.ldAdInit=w.ldAdInit||[];w.ldAdInit.push({slot:16850753759421286,size:[300, 300],id:"ld-2737-9364"});if(!d.getElementById(i)){var j=d.createElement(s),p=d.getElementsByTagName(s)[0];j.async=true;j.src="//cdn2.decide.dev/_js/ajs.js";j.id=i;p.parentNode.insertBefore(j,p);}})(window,document,"script","ld-ajs");</script>';

    return (
    <div className={`${className} ad google-ad googleAd google-sponsored-links ads4 fullSizeAd`}>
        <ErrorBoundary>
            <iframe
                title="decideco"
                width="100%"
                height="320"
                frameBorder="0"
                scrolling="no"
                srcDoc={`
          <html>
            <head>
            ${iframeContent}
            </head>
            <body>
             <div id="ld-2737-9364" />
            </body>
          </html>
        `}
            />
        </ErrorBoundary>
    </div>)

        ;
})`
    padding: 16px 12px;
  ${({theme, expand}) =>
          `
    & {
        border-${expand === 'card' ? 'top' : 'bottom'}: 1px solid ${theme.color.name === 'dark' ? themecolors.dark_background_4 : themecolors.lighter_border};
    }
    `
  }
`;

export const MgidAd = styled(({className}) => {

    const iframeContent = '<!-- Composite Start -->\n' +
        '<div id="M811716ScriptRootC1586031"></div>\n' +
        '<script src="https://jsc.mgid.com/c/o/communities.win.1586031.js" async></script>\n' +
        '<!-- Composite End -->';

    return (
        <div className={`${className} ad google-ad googleAd google-sponsored-links ads4 fullSizeAd`}>
            <ErrorBoundary>
                <iframe
                    style={{maxWidth: '400px', margin: '0 auto'}}
                    title="mgid"
                    width="100%"
                    height="342"
                    frameBorder="0"
                    scrolling="no"
                    srcDoc={`
          <html>
            <head>
            ${iframeContent}
            </head>
            <body>
             <div id="ld-2737-9364" />
            </body>
          </html>
        `}
                />
            </ErrorBoundary>
        </div>)

        ;
})`
  padding: 16px 12px;
  ${({theme}) =>
          `& {
    border-top: 1px solid ${theme.color.name === 'dark' ? themecolors.dark_background_4 : themecolors.lighter_border};
}`
  }
`;


const PreAd = ({adUnits, feedKey, index, view, impress, config, placement}) => {

    const loggedIn = useLoggedIn();

    const [rand, setRand] = useState(Math.floor(Math.random() * 100));
    const isFirstParty = useBaseCommunity() === "home";

    if (!config) return false;

    const {rate, showToFirstParty, showToThirdParty, showToGuests, showToUsers} = config;

    if (isFirstParty && !showToFirstParty) return false;
    if (!isFirstParty && !showToThirdParty) return false;

    if (loggedIn && !showToUsers) return false;
    if (!loggedIn && !showToGuests) return false;

    if (rand > rate) return false;

    if (placement === "mobileWebPost") {
        return <UnderPostUnit adUnits={adUnits} view={view} impress={impress} />;
    } else if (placement === "mobileWebFeedCard") {
        return <InFeedCard feedKey={feedKey} index={index} adUnits={adUnits} view={view} impress={impress} />
    } else if (placement === "mobileWebFeedCardSmall") {
        return <InFeedCardSmall feedKey={feedKey} index={index} adUnits={adUnits} view={view} impress={impress} />
    } else if (placement === "mobileWebFeedCondensed") {
        return <InFeedCondensed feedKey={feedKey} index={index} adUnits={adUnits} view={view} impress={impress} />
    }
    return false;
};

export default AdUnit;